import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
// import { ToasterService } from 'angular2-toaster';
// import { WebServiceService } from '../../shared/services/web-service.service';
// import { LocalStorageService } from '../../shared/services/storage/local-storage.service';
@Component({
  selector: 'app-generic-attachment',
  templateUrl: './generic-attachment.component.html',
  styleUrls: ['./generic-attachment.component.scss']
})
export class GenericAttachmentComponent implements OnInit {

  @Input() attachment: any;
  @Input() title: any;
  // company_setup: any = {};
  // isProcessing:boolean=true;
  @Output()
  sendAction = new EventEmitter()
  constructor(){

  }
  // constructor(private toasterService: ToasterService, private webService: WebServiceService,public _localStorageService: LocalStorageService) {
  // }
  ngOnInit() {
    this.attachment=Array.isArray(this.attachment)?this.attachment:[];
    // this.GetCompanySetUpData();
  }
  getFile(url: string) {
    if (url) {
      window.open(url, '_blank');
      // window.location.href = url ? url : ''
    }
  }
  
  // GetCompanySetUpData() {
  //   // if (this.company_setup.product_catalog_id != undefined && this.company_setup.product_catalog_id != '') {
  //   //   return false;
  //   // }
  //   let req = {
  //   }
  //   this.company_setup = {}
  //   this.isProcessing=true;
  //  this.webService.commonPostMethod("Update_company_meta/ajax_getall_bycompany", req).subscribe(
  //     data => {
  //       if (data.status) {
  //         this.company_setup = {}
  //         this.company_setup = data.response ? data.response : {}

  //         this.title=this.company_setup.custom_name_for_supporting_document?this.company_setup.custom_name_for_supporting_document:'Attachments';

  //       }
  //       else {
  //         this.toasterService.pop('error', "Error", data.message);
  //       }
  //       this.isProcessing=false;
  //     }, error => {
  //       this.isProcessing=false;
  //       this.toasterService.pop("error", "Error", "Something Went Wrong");

  //     }
  //   )
  // }
}



// WEBPACK FOOTER //
// /codebuild/output/src583407337/src/src/app/generic-ui-components/generic-attachment/generic-attachment.component.ts